<a class="nav-cell" (click)="clickHandle.emit()">
  {{ value }}
  <ng-content></ng-content>
</a>